import { AuthError, type AuthErrorCode } from '@nx/shared';

export function mapFirebaseError(error: unknown): AuthError {
  if (typeof error === 'object' && error && 'code' in error) {
    const code = String((error as { code?: string }).code);
    switch (code) {
      case 'auth/invalid-credential':
      case 'auth/wrong-password':
        return new AuthError('auth/invalid-credentials', 'Invalid email or password.', error);
      case 'auth/user-not-found':
        return new AuthError('auth/user-not-found', 'Account not found. Please sign up first.', error);
      case 'auth/email-already-in-use':
        return new AuthError(
          'auth/email-already-in-use',
          'This email is already registered. Please sign in.',
          error,
        );
      case 'auth/weak-password':
        return new AuthError('auth/weak-password', 'Password is too short. Use at least 6 characters.', error);
      case 'auth/operation-not-allowed':
        return new AuthError(
          'auth/operation-not-allowed',
          'Email/password sign-in is not enabled for this Firebase project. In Firebase Console → Authentication → Sign-in method, enable Email/Password, then try again.',
          error,
        );
      case 'auth/network-request-failed':
        return new AuthError('auth/network-error', 'Network error. Please try again later.', error);
      case 'permission-denied':
        return new AuthError(
          'auth/permission-denied',
          'Permission denied. If you just signed up, try again after rules are deployed, or contact support.',
          error,
        );
      default:
        return new AuthError('auth/unknown', 'Authentication failed. Please try again later.', error);
    }
  }
  if (error instanceof AuthError) return error;
  return new AuthError('auth/unknown', 'Authentication failed. Please try again later.', error);
}

export function isAuthErrorCode(value: string): value is AuthErrorCode {
  return value.startsWith('auth/');
}
